/* eslint-disable import/prefer-default-export */
export const SET_MODEL_DATA = 'setModelData';



// WEBPACK FOOTER //
// ./src/modules/TaskEngine/_store/mutations_type.js